<template lang="pug" src="./modal-office-tour.pug"></template>

<script>
export default {
  computed: {
    props () {
      return this.$store.state.pages['home'].office_tour
    }
  },
  data () {
    return {
      active: 0,
      activeOption: 0,
      office: false,
      zoom: false
    }
  },
  methods: {
    move (s) {
      s === 'next' ? (this.active === (this.props.location_1.images.length - 1) ? this.active = 0 : this.active++) : (this.active === 0 ? this.active = (this.props.location_1.images.length - 1) : this.active--)
    },
    moveOption (s) {
      s === 'next' ? (this.activeOption === (this.props.location_2.images.length - 1) ? this.activeOption = 0 : this.activeOption++) : (this.activeOption === 0 ? this.activeOption = (this.props.location_2.images.length - 1) : this.activeOption--)
    },
    hover (i) {
      this.zoom = i
    },
    location (i) {
      this.office = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/modal-office-tour/modal-office-tour.vue